import { Controller } from "@hotwired/stimulus";

type ScreenContext = { path?: string; label?: string; record_type?: string; record_id?: number; organization_id?: number };
type Reference = { id: number; type: string; name: string; path?: string };

export default class extends Controller<HTMLElement> {
  static targets = ["label", "pill", "field"];

  declare readonly labelTargets: HTMLElement[];
  declare readonly pillTargets: HTMLElement[];
  declare readonly fieldTargets: HTMLInputElement[];
  private screenContext: ScreenContext = {};
  private selectedContext: ScreenContext | null = null;

  connect(): void {
    this.pageChanged();
  }

  pageChanged(): void {
    const marker = document.getElementById("page_context");
    if (!marker) return;
    const next = JSON.parse(marker.dataset.context || "{}") as ScreenContext;
    const changedOrganization = this.screenContext.organization_id !== undefined &&
      this.screenContext.organization_id !== next.organization_id;
    this.screenContext = next;
    if (changedOrganization) {
      this.selectedContext = null;
      this.dispatch("organization-changed");
    }
    this.sync();
  }

  selectReference(event: CustomEvent<{ user: Reference }>): void {
    const reference = event.detail.user;
    if (reference.type === "AssistantSkill" || !reference.path) return;
    this.selectedContext = {
      path: reference.path, label: reference.name, record_type: reference.type,
      record_id: reference.id, organization_id: this.screenContext.organization_id,
    };
    this.sync();
  }

  clear(): void {
    this.selectedContext = null;
    this.pageChanged();
    this.sync();
    this.element.querySelector<HTMLElement>('[data-assistant-composer-target="input"]')?.focus();
  }

  labelTargetConnected(): void {
    this.sync();
  }

  pillTargetConnected(): void {
    this.sync();
  }

  fieldTargetConnected(field: HTMLInputElement): void {
    this.writeField(field);
  }

  private sync(): void {
    this.pillTargets.forEach((pill) => { pill.hidden = this.selectedContext === null; });
    this.labelTargets.forEach((label) => {
      label.textContent = this.selectedContext?.label || "";
      label.title = this.selectedContext?.path || "";
    });
    this.fieldTargets.forEach((field) => this.writeField(field));
  }

  private writeField(field: HTMLInputElement): void {
    const key = field.dataset.contextKey as keyof ScreenContext;
    field.value = String((this.selectedContext || this.screenContext)[key] || "");
  }
}
